import {
  ChangeDetectionStrategy,
  Component, Input, ViewEncapsulation
} from '@angular/core';

export interface XiloDialogConfig {
  header?: XiloDialogHeader;
  message?: string;
}

// TODO: make styling changes, appending color css class instead of isRed
export interface XiloDialogHeader {
  title: string;
  showClose?: boolean;
  showBorder?: boolean;
  icon?: string;
  isRed?: boolean;
}
/**
* @description The dialog element is a component of the xilo library
* @example No Form:
  <xilo-lib-dialog [xiloDialogConfig]="{
      header: {
        title: 'test',
        showClose: true,
        showBorder: false
    },
    message:'sample message'
  }"
  >
    <div class="xilo-dialog__footer gap-4 grid grid-cols-2 border-t-2 border-gray-20">
        <button type="button" (click)="Sample()" xilo-button color="primary-border">Cancel</button>
        <button type="submit" xilo-button color="primary">Submit</button>
    </div>
  </xilo-lib-dialog>
* @example With Form:
  <xilo-lib-dialog [xiloDialogConfig]="{
      header: {
        title: 'test w/ form',
        showClose: true,
        showBorder: false
    }
  }"
  >
  <form class="xilo-dialog__form">
      <div class="xilo-dialog__body">
      </div>
      <div class="xilo-dialog__footer gap-4 grid grid-cols-2 border-t-2 border-gray-20">
          <button type="button" xilo-button color="primary-border">Cancel</button>
          <button type="submit" xilo-button color="primary">Save Draft</button>
      </div>
  </form>
  </xilo-lib-dialog>
* @param xiloDialogConfig Defines the header and body message, the footer require the xilo-dialog__footer class.
* @param summary to determine how the buttons within a footer should be layed out we need to pass this class along the xilo_dialog__footer grid-cols-x.
*/
@Component({
  selector: 'xilo-lib-dialog',
  template: `
    <xilo-lib-dialog-header
      [header]="xiloDialogConfig.header"
    ></xilo-lib-dialog-header>
    <ng-container *ngIf="xiloDialogConfig.message; else formBody">
      <div class="xilo-dialog__body">{{xiloDialogConfig.message}}</div>
    </ng-container>
    <ng-template #formBody>
      <ng-content select=".xilo-dialog__form"></ng-content>
    </ng-template>
    <ng-content select=".xilo-dialog__footer, .grid"></ng-content>
  `,
  styleUrls:['./../dialog.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class XiloBaseDialogComponent {
  @Input() xiloDialogConfig: XiloDialogConfig;
}
